// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dropdown_container__hg10Z {
  height: 100%;
  overflow: scroll;
}

.Dropdown_recentRange__ScJaA {
  padding: 4px 6px;
  border-radius: var(--mantine-radius-sm);
  border: 1px solid var(--mantine-color-gray-1);
  justify-content: space-between;
}
.Dropdown_recentRange__ScJaA:hover {
  background-color: var(--mantine-color-gray-0);
}

.Dropdown_quickRangeButton__XB2HQ {
  transition: all 0.2s;
  padding: 4px 6px;
  border-radius: var(--mantine-radius-sm);
  border: 1px solid var(--mantine-color-gray-1);
}
.Dropdown_quickRangeButton__XB2HQ:hover {
  background-color: var(--mantine-color-gray-0);
}

.Dropdown_recentRangeContainer__76NER {
  height: 6.5rem;
  overflow-y: auto;
}

.Dropdown_quickRangeContainer__0adf1 {
  height: 17.5rem;
  overflow-y: auto;
}

@media screen and (max-width: 48em) {
  .Dropdown_dropdown__-O33p {
    min-height: 100dvh !important;
    width: 100vw !important;
    top: 0 !important;
    left: 0 !important;
    z-index: 1000 !important;
    border: none;
    padding: 0;
  }
  .Dropdown_container__hg10Z {
    height: 100dvh;
    width: 100%;
    padding: 0 1rem 0.5rem;
  }
  .Dropdown_recentRangeContainer__76NER {
    height: 100%;
  }
  .Dropdown_quickRangeContainer__0adf1 {
    height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DateRangeFilter/Dropdown.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,uCAAA;EACA,6CAAA;EACA,8BAAA;AACF;AACE;EACE,6CAAA;AACJ;;AAGA;EACE,oBAAA;EACA,gBAAA;EACA,uCAAA;EACA,6CAAA;AAAF;AAEE;EACE,6CAAA;AAAJ;;AAIA;EACE,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;AADF;;AAIA;EACE;IACE,6BAAA;IACA,uBAAA;IACA,iBAAA;IACA,kBAAA;IACA,wBAAA;IACA,YAAA;IACA,UAAA;EADF;EAIA;IACE,cAAA;IACA,WAAA;IACA,sBAAA;EAFF;EAKA;IACE,YAAA;EAHF;EAMA;IACE,YAAA;EAJF;AACF","sourcesContent":[".container {\n  height: 100%;\n  overflow: scroll;\n}\n\n.recentRange {\n  padding: 4px 6px;\n  border-radius: var(--mantine-radius-sm);\n  border: 1px solid var(--mantine-color-gray-1);\n  justify-content: space-between;\n\n  &:hover {\n    background-color: var(--mantine-color-gray-0);\n  }\n}\n\n.quickRangeButton {\n  transition: all 0.2s;\n  padding: 4px 6px;\n  border-radius: var(--mantine-radius-sm);\n  border: 1px solid var(--mantine-color-gray-1);\n\n  &:hover {\n    background-color: var(--mantine-color-gray-0);\n  }\n}\n\n.recentRangeContainer {\n  height: 6.5rem;\n  overflow-y: auto;\n}\n\n.quickRangeContainer {\n  height: 17.5rem;\n  overflow-y: auto;\n}\n\n@media screen and (max-width: 48em) {\n  .dropdown {\n    min-height: 100dvh !important;\n    width: 100vw !important;\n    top: 0 !important;\n    left: 0 !important;\n    z-index: 1000 !important;\n    border: none;\n    padding: 0;\n  }\n\n  .container {\n    height: 100dvh;\n    width: 100%;\n    padding: 0 1rem 0.5rem;\n  }\n\n  .recentRangeContainer {\n    height: 100%;\n  }\n\n  .quickRangeContainer {\n    height: 100%;\n  }\n}\n\n@media screen and (max-width: 48em) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Dropdown_container__hg10Z`,
	"recentRange": `Dropdown_recentRange__ScJaA`,
	"quickRangeButton": `Dropdown_quickRangeButton__XB2HQ`,
	"recentRangeContainer": `Dropdown_recentRangeContainer__76NER`,
	"quickRangeContainer": `Dropdown_quickRangeContainer__0adf1`,
	"dropdown": `Dropdown_dropdown__-O33p`
};
export default ___CSS_LOADER_EXPORT___;
